exports = module.exports = require("../../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{padding:0;margin:0}.mt10{margin-top:10px}.login-wrap{background:#324157}.header{background:#242f42}.content{background:none repeat scroll 0 0 #fff;position:absolute;left:250px;right:0;top:70px;bottom:0;width:auto;padding:40px;box-sizing:border-box;overflow-y:scroll}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader!./src/assets/css/common.css
// module id = 33
// module chunks = 8